// Centralized logout helpers for the frontend.
// Keep this file side-effect free (no React imports) so any module can use it.

/**
 * Clears common auth/session-related storage keys used across the app.
 * This is intentionally conservative (only known keys) to avoid nuking unrelated data.
 */
export const clearAuthStorage = () => {
  try {
    // Auth/user identity
    localStorage.removeItem('user');
    localStorage.removeItem('user_id');
    localStorage.removeItem('user_profile_timestamp');
    localStorage.removeItem('last_auth_check');

    // Cached user data
    localStorage.removeItem('profileStats');
    localStorage.removeItem('profileStatsTimestamp');
    localStorage.removeItem('workout_profile');
    localStorage.removeItem('workout_profile_timestamp');
    localStorage.removeItem('no_workout_profile');
    localStorage.removeItem('no_workout_profile_timestamp');

    // UX/state caches that are user-bound
    localStorage.removeItem('onboarding_dismissed_timestamp');
    localStorage.removeItem('onboarding_dismissed_user_id');
    localStorage.removeItem('hasRated');
    localStorage.removeItem('exerciseModalTourSeen');
    localStorage.removeItem('profile_prompt_dismissed_user_id');
    localStorage.removeItem('profile_prompt_dismissed_timestamp');
  } catch (e) {
    // ignore storage errors (private mode, quota, etc)
  }
};

/**
 * Force logout and notify the rest of the app.
 * - Clears auth storage
 * - Dispatches a `storage` event and a `userLogout` custom event (some components listen to these)
 * - Optionally redirects
 */
export const forceLogout = ({ redirectTo = '/', reason } = {}) => {
  clearAuthStorage();

  try {
    // Notify listeners that rely on these events
    window.dispatchEvent(new Event('storage'));
    window.dispatchEvent(new CustomEvent('userLogout', { detail: { reason } }));
  } catch (e) {
    // ignore event dispatch issues
  }

  if (redirectTo) {
    try {
      // Use replace to avoid the user navigating back into an invalid session state
      window.location.replace(redirectTo);
    } catch (e) {
      window.location.href = redirectTo;
    }
  }
};



